var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_60e6c3ea"]},_vm.$listeners),[_c('cube-button',{attrs:{"outline":"","active":""}},[_vm._v("outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }